export const CHECKOUT = {
  V2: 'VERSION_2',
  V3: 'VERSION_3',
  V4: 'VERSION_4',
  A: 'A',
  B: 'B',
};

export const SHOW_DISCLAIMER = {
  MX: 'MX',
  PE: 'PE',
  CO: 'CO',
  CL: 'CL',
  BR: 'BR',
  AR: 'AR',
  BO: 'BO',
  // US: 'US',
  // EC: 'EC',
  ES: 'ES',
  CR: 'CR',
};

export const PAYMENT_METHODS_TITLES = {
  STRIPE: 'Stripe',
  PAYPAL: 'Paypal',
  EPAYCO_EFECTY: 'Epayco',
  EPAYCO_PSE: 'Epayco - PSE',
  PAYU_PERU: 'PayU Peru',
  PAGO_EFECTIVO: 'Pago efectivo',
  STRIPE_MEXICO: 'Stripe Mexico',
  COMPROPAGO_PSEI: 'ComproPago SPEI',
  COMPROPAGO: 'Compropago',
  EPAYCO_BALOTO: 'Epayco - Baloto',
  PAYNET: 'Openpay - Store',
  CONEKTA_OXXO: 'Conekta OXXO',
  CONEKTA_CARD: 'Conekta Card',
  EBANX_CARD: 'Ebanx Card Brasil',
  EBANX_CARD_AR: 'Ebanx Card Argentina',
  BRASIL_OFFLINE: 'Ebanx Bank Transfer',
  RAPI_PAGO: 'Ebanx Rapi Pago',
  PAGO_FACIL: 'Ebanx Pago Facil',
  EBANX_OFFLINE_ARG: 'EBANX_OFFLINE_ARG',
  CONEKTA_SPEI: 'Conekta SPEI',
  RAPPI_COLOMBIA: 'Rappi Colombia',
  RAPPI_MEXICO: 'Rappi Mexico',
  DLOCAL_MEXICO: 'dLocal Mexico',
  DLOCAL_AR: 'dLocal Argentina',
  DLOCAL_PERU: 'dLocal Peru',
  DLOCAL_COLOMBIA: 'dLocal Colombia',
  DLOCAL_CHILE: 'dLocal Chile',
  MERCADOPAGO_ARGENTINA: 'Mercado Pago Argentina',
  MERCADOPAGO_CARD_MEXICO: 'Mercado Pago Card Mexico',
  MERCADOPAGO_MEXICO: 'Mercado Pago Mexico',
};

export const METHODS = {
  STRIPE: 'Stripe',
  PAYPAL: 'Paypal',
  EPAYCO_EFECTY: 'Epayco',
  EPAYCO_PSE: 'Epayco - PSE',
  PAYU_PERU: 'PayU Peru',
  PAGO_EFECTIVO: 'Pago efectivo',
  STRIPE_MEXICO: 'Stripe Mexico',
  COMPROPAGO_PSEI: 'ComproPago SPEI',
  COMPROPAGO: 'Compropago',
  EPAYCO_BALOTO: 'Epayco - Baloto',
  PAYNET: 'Openpay - Store',
  CONEKTA_OXXO: 'Conekta OXXO',
  CONEKTA_CARD: 'Conekta Card',
  EBANX_CARD: 'Ebanx Card Brasil',
  EBANX_CARD_AR: 'Ebanx Card Argentina',
  BRASIL_OFFLINE: 'Ebanx Bank Transfer',
  RAPI_PAGO: 'Ebanx Rapi Pago',
  PAGO_FACIL: 'Ebanx Pago Facil',
  EBANX_OFFLINE_ARG: 'EBANX_OFFLINE_ARG',
  CONEKTA_SPEI: 'Conekta SPEI',
  RAPPI_COLOMBIA: 'Rappi Colombia',
  RAPPI_MEXICO: 'Rappi Mexico',
  DLOCAL_MEXICO: 'dLocal Mexico',
  DLOCAL_AR: 'dLocal Argentina',
  DLOCAL_PERU: 'dLocal Peru',
  DLOCAL_COLOMBIA: 'dLocal Colombia',
  DLOCAL_CHILE: 'dLocal Chile',
  MERCADOPAGO_ARGENTINA: 'Mercado Pago Argentina',
  MERCADOPAGO_CARD_MEXICO: 'Mercado Pago Card Mexico',
  MERCADOPAGO_MEXICO: 'Mercado Pago Mexico',
  NIUBIZ: 'Niubiz Digital Wallet',
  TESTING: 'Testing Payment Method',
};

export const CARD_PAYMENT_METHOD = [
  METHODS.STRIPE,
  METHODS.STRIPE_MEXICO,
  METHODS.EBANX_CARD,
  METHODS.EBANX_CARD_AR,
  METHODS.PAYU_PERU,
];

export const brazilState = [
  { value: 'AC', label: 'Acre' },
  { value: 'AL', label: 'Alagoas' },
  { value: 'AP', label: 'Amapá' },
  { value: 'AM', label: 'Amazonas' },
  { value: 'BA', label: 'Bahia' },
  { value: 'CE', label: 'Ceará' },
  { value: 'DF', label: 'Distrito Federal' },
  { value: 'ES', label: 'Espírito Santo' },
  { value: 'GO', label: 'Goiás' },
  { value: 'MA', label: 'Maranhão' },
  { value: 'MT', label: 'Mato Grosso' },
  { value: 'MS', label: 'Mato Grosso do Sul' },
  { value: 'MG', label: 'Minas Gerais' },
  { value: 'PA', label: 'Pará' },
  { value: 'PB', label: 'Paraíba' },
  { value: 'PR', label: 'Paraná' },
  { value: 'PE', label: 'Pernambuco' },
  { value: 'PI', label: 'Piauí' },
  { value: 'RJ', label: 'Rio de Janeiro' },
  { value: 'RN', label: 'Rio Grande do Norte' },
  { value: 'RS', label: 'Rio Grande do Sul' },
  { value: 'RO', label: 'Rondônia' },
  { value: 'RR', label: 'Roraima' },
  { value: 'SC', label: 'Santa Catarina' },
  { value: 'SP', label: 'São Paulo' },
  { value: 'SE', label: 'Sergipe' },
  { value: 'TO', label: 'Tocantins' },
];

export const URLS = {
  stripev2: 'https://js.stripe.com/v2/',
  paypal: 'https://www.paypalobjects.com/api/checkout.js',
  mercadopago: 'https://sdk.mercadopago.com/js/v2',
  conekta: 'https://cdn.conekta.io/js/latest/conekta.js',
  ebanx: 'https://js.ebanx.com/ebanx-libjs-latest.min.js',
  payu: 'https://gateway.payulatam.com/ppp-web-gateway/javascript/PayU.js',
  rappi:
    window?.RAPPI_DEBUG_MODE === 'True'
      ? 'https://microservices.dev.rappi.com/rms/merchant-services/sdk/v2/rms.js'
      : 'https://services.rappi.com/rms/merchant-services/sdk/v2/rms.js',
  dlocal:
    window?.DLOCAL_DEBUG === 'True'
      ? 'https://static-sandbox.dlocal.com/modules/fields/2.2.2-5/parent.js'
      : 'https://static.dlocal.com/modules/fields/2.3.0/parent.js',
};

const inputDefaultValues = {
  zipHint: '',
  phoneHint: '',
  countryCod: '+51',
  phoneMaxLength: 10,
  zipMaxLength: 9,
  documentMaxLength: 32,
  zipDescription: '',
  DocDescription: '',
};

export const inputValues = {
  [METHODS.EBANX_CARD]: {
    // Brasil online
    ...inputDefaultValues,
    countryCod: '+55',
    phoneMaxLength: 15, // (85) 2284-7035
    documentMaxLength: 14, // 853.513.468-93
    documementHint: 'exemplo: 853.513.468-93', // pt
    zipHint: 'exemplo: 61919-230', // pt
    phoneHint: '(__) ____-____',
  },
  [METHODS.BRASIL_OFFLINE]: {
    // Brasil offline
    ...inputDefaultValues,
    countryCod: '+55',
    phoneMaxLength: 15, // (85) 2284-7035
    documentMaxLength: 14, // 853.513.468-93
    documementHint: 'exemplo: 853.513.468-93', // pt
    zipHint: 'exemplo: 0000-000', // pt
    phoneHint: '(__) ____-____',
  },
  [METHODS.EBANX_CARD_AR]: {
    ...inputDefaultValues,
    countryCod: '+54',
    zipMaxLength: 5, // 	C1017
    documentMaxLength: 8, // 30-52135353-1
    documementLabel: 'DNI',
    documementHint: '',
    zipHint: '',
    phoneMaxLength: 12,
    zipDescription: 'Ejemplo: C1014 o B1827',
    DocDescription: 'Ejemplo: 5213535 o 52135353',
  },
  [METHODS.EBANX_OFFLINE_ARG]: {
    ...inputDefaultValues,
    countryCod: '+54',
    zipMaxLength: 5, // 	C1017
    documentMaxLength: 8, // 30-52135353-1
    documementLabel: 'DNI',
    documementHint: '',
    zipHint: 'C0000',
    phoneMaxLength: 12,
  },
  [METHODS.CONEKTA_CARD]: {
    ...inputDefaultValues,
    countryCod: '+52',
  },
  default: inputDefaultValues,
};

export const AMPLITUDE_EVENTS = {
  LabelOne: 'Leave',
  LabeLTwo: 'Stay',
};

export const PERU_OFFLINE_PAYMENT_LIMIT_FOR_FIELDS = 700;
